module.exports = __webpack_public_path__ + "img/whatsapp.d1acb2cd.svg";